<template>
	<div>
		<Header></Header>
		<loginheader flagg="1" num="4"></loginheader>
		<div class="novel-con">
			<div class="mynav">
				<publicnovul :novelList="novelList"></publicnovul>
			</div>
			<publicpaging :total="page.total" :pagesize="6"></publicpaging>
		</div>
		<Fotter></Fotter>
	</div>
</template>

<script>
	import Header from "../Header.vue";
	import Fotter from "../Fotter.vue";
	import loginheader from "../loginheader.vue";
	import publicnovul from "../publicnovul.vue";
	import publicpaging from "../publicpaging.vue";

	export default {
		name: "App",
		props: ["b"],
		components: {
			Header,
			Fotter,
			loginheader,
			publicnovul,
			publicpaging
		},
		data() {
			return {
				datalist: "",
				novelList: "",
				page: ""
			};
		},
		methods: {
			getpagedata(page = 1, size = 6) {
				this.$http.get(`book/3?page=${page}&size=${size}`).then(res => {
					this.novelList = res.body.data.data;
				});
			}
		},
		beforeCreate() {
			this.$http.get(`book/3?page=1&size=6`).then(res => {
				this.novelList = res.body.data.data;
				this.page = res.body.data;
			});
		},
		mounted() {
			//初始化
			this.$router.push({
					path: "works",
					query: {
						id: 13
					}
				});
		},
	};
</script>

<style scoped="scoped">
	.novel-con {
		width: 1200px;
		box-sizing: border-box;
		margin: 30px auto;
		min-height: 50vh;
	}
</style>



// WEBPACK FOOTER //
// src/components/Novel/Novel.vue